module.exports = __webpack_public_path__ + "img/116012.d48ef174.png";